import $ from 'jquery';

const SELECTOR_TOGGLE_BUTTON = '[data-widget="pushmenu"]';

document.addEventListener('turbolinks:load', () => {
  $.fn.PushMenu.call($(SELECTOR_TOGGLE_BUTTON), '_init');
});
